import { useEffect } from 'react';
import { AgencyEditModalHeader } from './AgencyEditModalHeader';
import { AgencyEditModalFormWrapper } from './AgencyEditModalFormWrapper';

const AgencyEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <AgencyEditModalHeader />
            <div className='modal-body scroll-y mx-5 mx-xl-5 my-1'>
              <AgencyEditModalFormWrapper />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};

export { AgencyEditModal };
